import { useEffect, useState } from "react";
import styles from "./Countdown.module.css";
import { useLanguage } from "../LanguageContext";

function useCountdown(deadline) {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  const remaining = Math.max(0, deadline - now);
  return {
    hours: Math.floor(remaining / 3_600_000),
    minutes: Math.floor((remaining / 60_000) % 60),
    seconds: Math.floor((remaining / 1000) % 60),
  };
}

const pad = (n) => String(n).padStart(2, "0");

// Hours : minutes : seconds countdown to `deadline` (ms timestamp)
export default function Countdown({ deadline, className = "" }) {
  const { t } = useLanguage();
  const { hours, minutes, seconds } = useCountdown(deadline);

  const units = [
    { value: hours, labelKey: "port_hours" },
    { value: pad(minutes), labelKey: "port_minutes" },
    { value: pad(seconds), labelKey: "port_seconds" },
  ];

  return (
    <div className={`${styles.countdown} ${className}`} role="timer" aria-live="off">
      {units.map((unit, i) => (
        <div key={unit.labelKey} className={styles.group}>
          {i > 0 && <span className={styles.sep} aria-hidden="true">:</span>}
          <div className={styles.unit}>
            <span className={styles.value}>{unit.value}</span>
            <span className={styles.label}>{t(unit.labelKey)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
